'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import CollapseFieldWrapper from './shared/CollapseFieldWrapper';
import DateTimeInput from '../inputs/DateTimeInput';
export default class DateTimeField extends Component {
  render() {
    const {
      autoFocus,
      collapsed,
      disabled,
      formData,
      idSchema,
      isAdditionalProperty,
      name,
      onChange,
      readOnly,
      registry,
      required,
      schema
    } = this.props;
    const {
      title
    } = schema;
    const {
      formContext
    } = registry;
    return /*#__PURE__*/_jsx(CollapseFieldWrapper, {
      collapsed: collapsed,
      formData: formData,
      isAdditionalProperty: isAdditionalProperty,
      children: /*#__PURE__*/_jsx(DateTimeInput, {
        autoFocus: autoFocus,
        formContext: formContext,
        id: idSchema && idSchema.$id,
        disabled: disabled,
        label: title || name,
        onChange: onChange,
        readOnly: readOnly,
        required: required,
        schema: schema,
        value: formData || ''
      })
    });
  }

}
DateTimeField.propTypes = {
  autoFocus: PropTypes.bool,
  collapsed: PropTypes.bool,
  disabled: PropTypes.bool,
  formData: PropTypes.any,
  idSchema: PropTypes.object,
  isAdditionalProperty: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  readOnly: PropTypes.bool,
  registry: PropTypes.object,
  required: PropTypes.bool,
  schema: PropTypes.object
};